export default __webpack_public_path__ + "static/circleforward-e50bd4347db679db69bd3f345a8831e3.png";